<template>
  <b-modal
    @show="onShow"
    @hidden="onHidden"
    ref="modal"
    v-model="opened"
    size="xl"
    title="Copy limits"
    static
    lazy
    hide-footer
  >
    <form @submit.stop.prevent="handleSubmit">
      <div class="align-content-center">
        <div class="d-flex flex-row justify-content-center mb-3">
          <span class="font-weight-bold"
            ><i class="fas fa-arrow-up" /> From</span
          >
        </div>
      </div>
      <b-row>
        <div class="col-lg-4 col-sm-12">
          <OperatorSelector
            v-model="selectedOperator"
            :operators="operatorsToMultiselectOptions"
            :disabled="isLoadingFilter"
            :use-scroll="true"
            @change="loadFilter(true)"
          />
        </div>
        <div class="col-lg-5 col-sm-12">
          <b-form-group>
            <div
              class="custom-control custom-checkbox min-height-scroll"
              style="padding: 10px; border: 1px solid #ddd; border-radius: 5px; background-color: #f9f9f9;"
            >
              <div
                class="custom-control custom-checkbox"
                v-for="(tableFrom, index) in tablesFromOptions"
                :key="index"
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="tableFrom.checked"
                  :id="tableFrom.name + '-tableFrom'"
                  :disabled="isLoadingTablesFromOptions"
                />
                <label
                  class="custom-control-label"
                  :for="tableFrom.name + '-tableFrom'"
                >
                  <TableName :tableId="tableFrom.name"></TableName>
                </label>
              </div>
            </div>
            <b-button
              v-if="tablesFromOptions.length"
              @click="toggleAllFromTables"
              size="sm"
              class="toggle-link mt-2"
              :disabled="isLoadingFilter"
              >Toggle All</b-button
            >
            <template #label>
              <b-row align-h="between">
                <b-col cols="12">
                  <label>
                    <RouteIcon tables /> Tables:
                    <span v-if="isLoadingTablesFromOptions"
                      ><i class="fas fa-spinner fa-pulse"></i
                    ></span>
                    <span v-else
                      >({{ chosenFromTables.length }}/{{
                        tablesFromOptions.length
                      }})</span
                    >
                  </label>
                </b-col>
              </b-row>
            </template>
          </b-form-group>
        </div>
        <div class="col-lg-3 col-sm-12">
          <b-form-group>
            <div class="search-input-wrapper mb-2">
              <b-form-input
                v-model="currencyFromSearchQuery"
                placeholder="Search currency..."
              />
              <button
                v-if="currencyFromSearchQuery"
                class="clear-button"
                @click="currencyFromSearchQuery = ''"
                type="button"
              >
                ✕
              </button>
            </div>
            <div
              class="custom-control custom-checkbox min-height-scroll"
              style="padding: 10px; border: 1px solid #ddd; border-radius: 5px; background-color: #f9f9f9;"
            >
              <div
                class="custom-control custom-checkbox"
                v-for="(currencyFrom, index) in filteredCurrenciesFromOptions"
                :key="index"
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="currencyFrom.checked"
                  :id="currencyFrom.name + '-currencyFrom'"
                  :disabled="isLoadingCurrenciesFromOptions || (selectedLimitType !== null && selectedLimitType !== currencyFrom.limitType && !currencyFrom.checked)"
                />
                <label
                  class="custom-control-label"
                  :for="currencyFrom.name + '-currencyFrom'"
                  >{{ currencyFrom.displayName }}</label
                >
              </div>
            </div>
            <b-button
              v-if="currenciesFromOptions.length"
              @click="toggleAllFromCurrencies"
              size="sm"
              class="toggle-link mt-2"
              :disabled="isLoadingFilter"
              >Toggle All</b-button
            >
            <template #label>
              <b-row align-h="between">
                <b-col cols="12">
                  <label>
                    <RouteIcon currencies /> Currencies:
                    <span v-if="isLoadingCurrenciesFromOptions"
                      ><i class="fas fa-spinner fa-pulse"></i
                    ></span>
                    <span v-else
                      >({{ chosenFromCurrencies.length }}/{{
                        currenciesFromOptions.length
                      }})</span
                    >
                    <span v-if="selectedLimitType !== null && chosenFromCurrencies.length > 0" class="ml-2 text-info">
                      [{{ chosenFromCurrencies[0].limitTypeName }}]
                    </span>
                  </label>
                </b-col>
              </b-row>
            </template>
          </b-form-group>
        </div>
      </b-row>

      <div class="align-content-center">
        <div class="d-flex flex-row justify-content-center mb-3">
          <span class="font-weight-bold"
            ><i class="fas fa-arrow-down" /> To</span
          >
        </div>
      </div>
      <b-row>
        <div class="col-lg-4 col-sm-12">
          <b-form-group label-for="operators-to-input">
            <div class="search-input-wrapper mb-2">
              <b-form-input
                v-model="operatorToSearchQuery"
                placeholder="Search operator..."
              />
              <button
                v-if="operatorToSearchQuery"
                class="clear-button"
                @click="operatorToSearchQuery = ''"
                type="button"
              >
                ✕
              </button>
            </div>
            <div class="min-height-scroll">
              <div
                v-for="(item, index) in filteredOperatorsToOptions"
                :key="index"
              >
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    v-model="item.checked"
                    :id="item.partner + '-operatorToPartner'"
                  />
                  <label
                    class="custom-control-label"
                    :for="item.partner + '-operatorToPartner'"
                    >{{ item.partner }}</label
                  >
                </div>
                <div class="operators ml-4">
                  <div
                    class="custom-control custom-checkbox"
                    v-for="(operatorTo, index2) in item.operators"
                    :key="index2"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="operatorTo.checked"
                      :id="operatorTo.name + '-operatorTo'"
                    />
                    <label
                      class="custom-control-label"
                      style="font-weight: normal"
                      :for="operatorTo.name + '-operatorTo'"
                      >{{ operatorTo.name }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <b-button
              v-if="Object.keys(filteredOperatorsToOptions).length"
              @click="toggleAllToOperators"
              size="sm"
              class="toggle-link mt-2"
              >Toggle All</b-button
            >
            <template #label>
              <b-row align-h="between">
                <b-col cols="12">
                  <label>
                    <RouteIcon operators /> Operators:
                    <span
                      >({{ checkedOperators.length }}/{{
                        operatorsToCount
                      }})</span
                    >
                  </label>
                </b-col>
              </b-row>
            </template>
          </b-form-group>
        </div>
        <div class="col-lg-5 col-sm-12">
          <b-form-group label-for="tables-to-input">
            <div
              class="custom-control custom-checkbox min-height-scroll"
              style="padding: 10px; border: 1px solid #ddd; border-radius: 5px; background-color: #f9f9f9;"
            >
              <div
                class="custom-control custom-checkbox"
                v-for="(tableTo, index) in tablesToOptions"
                :key="index"
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="tableTo.checked"
                  :disabled="chosenFromTables.length > 1"
                  :id="tableTo.name + '-tableTo'"
                />
                <label
                  class="custom-control-label"
                  :for="tableTo.name + '-tableTo'"
                >
                  <TableName :tableId="tableTo.id"></TableName>
                </label>
              </div>
            </div>
            <b-button
              v-if="tablesToOptions.length"
              @click="toggleAllToTables"
              size="sm"
              class="toggle-link mt-2"
              :disabled="chosenFromTables.length > 1"
              >Toggle All</b-button
            >
            <template #label>
              <b-row align-h="between">
                <b-col cols="12">
                  <label>
                    <RouteIcon tables /> Tables:
                    <span
                      >({{ chosenToTables.length }}/{{
                        tablesToOptions.length
                      }})</span
                    >
                  </label>
                </b-col>
              </b-row>
            </template>
          </b-form-group>
        </div>
        <div class="col-lg-3 col-sm-12">
          <b-form-group label-for="currencies-to-input">
            <div class="search-input-wrapper mb-2">
              <b-form-input
                v-model="currencyToSearchQuery"
                placeholder="Search currency..."
              />
              <button
                v-if="currencyToSearchQuery"
                class="clear-button"
                @click="currencyToSearchQuery = ''"
                type="button"
              >
                ✕
              </button>
            </div>
            <div class="min-height-scroll">
              <div
                class="custom-control custom-checkbox"
                v-for="(currencyTo, index) in filteredCurrenciesToOptions"
                :key="index"
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :disabled="chosenFromCurrencies.length > 1"
                  v-model="currencyTo.checked"
                  :id="currencyTo.name + '-currencyTo'"
                />
                <label
                  class="custom-control-label"
                  :for="currencyTo.name + '-currencyTo'"
                  >{{ currencyTo.name }}</label
                >
              </div>
            </div>
            <b-button
              v-if="currenciesToOptions.length"
              @click="toggleAllToCurrencies"
              size="sm"
              class="toggle-link mt-2"
              :disabled="chosenFromCurrencies.length > 1"
              >Toggle All</b-button
            >
            <template #label>
              <b-row align-h="between">
                <b-col cols="12">
                  <label>
                    <RouteIcon currencies /> Currencies:
                    <span v-if="isLoadingCurrenciesToOptions"
                      ><i class="fas fa-spinner fa-pulse"></i
                    ></span>
                    <span v-else
                      >({{ chosenToCurrencies.length }}/{{
                        currenciesToOptions.length
                      }})</span
                    >
                  </label>
                </b-col>
              </b-row>
            </template>
          </b-form-group>
        </div>
      </b-row>

      <div class="align-content-center">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="d-flex flex-column">
            <b-form-checkbox
              v-model="rewriteExisting"
              :value="true"
              :unchecked-value="false"
              v-b-tooltip.hover.top
              :title="rewriteExistingTooltip"
              class="mb-2"
            >
              <span class="font-weight-bold">Rewrite existing</span>
              <i class="fas fa-question-circle ml-1 text-muted"></i>
            </b-form-checkbox>
            <b-form-checkbox
              v-model="removeExtraLimits"
              :value="true"
              :unchecked-value="false"
              v-b-tooltip.hover.top
              :title="removeExtraLimitsTooltip"
            >
              <span class="font-weight-bold text-warning">Remove extra limits</span>
              <i class="fas fa-exclamation-triangle ml-1 text-warning"></i>
            </b-form-checkbox>
          </div>
          <b-button
            variant="primary"
            @click="handleSubmit"
            :disabled="!canSubmitCopy"
            >Save</b-button
          >
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import TableName from './TableName'
import RouteIcon from '../RouteIcon'
import OperatorSelector from './OperatorSelector'

export default {
  data() {
    return {
      selectedOperator: null,
      rewriteExisting: false,
      removeExtraLimits: false,
      operatorOptions: [],
      currencyOptions: [],
      operatorsTo: [],
      operatorsToCount: 0,
      operatorsToMultiselectOptions: [],
      tablesFromOptions: [],
      tablesToOptions: [],
      currenciesFromOptions: [],
      currenciesToOptions: [],
      isLoadingTablesFromOptions: false,
      isLoadingCurrenciesFromOptions: false,
      isLoadingCurrenciesToOptions: false,
      isLoadingFilter: false,
      opened: true,
      currencyToSearchQuery: '',
      currencyFromSearchQuery: '',
      operatorToSearchQuery: ''
    }
  },
  components: {
    OperatorSelector,
    TableName,
    RouteIcon
  },
  computed: {
    canSubmitCopy() {
      if (this.selectedOperator === null) {
        return false
      }

      if (this.chosenFromTables.length === 0) {
        return false
      }

      if (this.chosenFromCurrencies.length === 0) {
        return false
      }

      if (this.checkedOperators.length === 0) {
        return false
      }

      if (this.chosenToTables.length === 0) {
        return false
      }

      if (this.chosenToCurrencies.length === 0) {
        return false
      }

      return true
    },
    chosenFromTables() {
      return this.tablesFromOptions.filter(({ checked }) => checked)
    },
    chosenFromTablesIds() {
      return this.chosenFromTables.map(({ id }) => id)
    },
    chosenToTables() {
      return this.tablesToOptions.filter(({ checked }) => checked)
    },
    chosenToCurrencies() {
      return this.currenciesToOptions.filter(({ checked }) => checked)
    },
    chosenFromCurrencies() {
      return this.currenciesFromOptions.filter(({ checked }) => checked)
    },
    selectedLimitType() {
      const chosen = this.chosenFromCurrencies
      return chosen.length > 0 ? chosen[0].limitType : null
    },
    chosenFromCurrenciesIds() {
      return this.chosenFromCurrencies.map(({ currency }) => currency)
    },
    chosenFromTablesString() {
      return JSON.stringify(this.chosenFromTables)
    },
    currenciesForSelect() {
      return this.$store.getters['limits/currenciesForSelect']
    },
    filteredCurrenciesToOptions() {
      if (!this.currencyToSearchQuery) return this.currenciesToOptions

      const searchLower = this.currencyToSearchQuery.toLowerCase()
      return this.currenciesToOptions.filter(currency =>
        currency.name.toLowerCase().includes(searchLower)
      )
    },
    filteredCurrenciesFromOptions() {
      if (!this.currencyFromSearchQuery) return this.currenciesFromOptions

      const searchLower = this.currencyFromSearchQuery.toLowerCase()
      return this.currenciesFromOptions.filter(currency =>
        currency.displayName.toLowerCase().includes(searchLower)
      )
    },
    filteredOperatorsToOptions() {
      if (!this.operatorToSearchQuery) return this.operatorsToMultiselectOptions

      const searchLower = this.operatorToSearchQuery.toLowerCase()
      const filtered = {}
      
      Object.keys(this.operatorsToMultiselectOptions).forEach(key => {
        const partnerGroup = this.operatorsToMultiselectOptions[key]
        const filteredOperators = partnerGroup.operators.filter(operator =>
          operator.name.toLowerCase().includes(searchLower)
        )
        
        if (filteredOperators.length > 0 || partnerGroup.partner.toLowerCase().includes(searchLower)) {
          filtered[key] = {
            ...partnerGroup,
            operators: partnerGroup.partner.toLowerCase().includes(searchLower) 
              ? partnerGroup.operators 
              : filteredOperators
          }
        }
      })
      
      return filtered
    },
    checkedPartners() {
      let ids = []
      Object.values(this.operatorsToMultiselectOptions).forEach(
        ({ checked, partnerId }) => {
          if (!checked) {
            return
          }
          ids.push(partnerId)
        }
      )
      return ids
    },
    checkedOperators() {
      let values = []
      Object.values(this.operatorsToMultiselectOptions).forEach(
        ({ operators }) => {
          operators.forEach(item => {
            if (!item.checked) {
              return
            }
            values.push(item.id)
          })
        }
      )

      return values
    },
    rewriteExistingTooltip() {
      return this.rewriteExisting 
        ? 'ENABLED: Will overwrite existing limits with new settings from source operator'
        : 'DISABLED: Will only copy limits that don\'t exist yet. Existing limits will be preserved'
    },
    removeExtraLimitsTooltip() {
      return this.removeExtraLimits
        ? 'DANGER: Will DELETE all limits from target operators that don\'t exist in source operator'
        : 'SAFE: Will preserve all existing limits in target operators'
    }
  },
  methods: {
    onShow() {},
    onHidden() {
      this.$emit('close')
    },
    handleSubmit() {
      const filter = ({ checked }) => checked
      const mapper = ({ id }) => id
      const currencyMapper = ({ currency }) => currency
      const limitTypeMapper = ({ limitType }) => limitType

      // Собираем уникальные типы лимитов из выбранных валют «From»
      const uniqueFromLimitTypes = Array.from(
        new Set(this.currenciesFromOptions.filter(filter).map(limitTypeMapper))
      )

      this.$http({
        url: '/api/v1/limits/copy',
        data: {
          fromOperator: this.selectedOperator,
          fromTables: this.chosenFromTables.map(mapper),
          fromCurrencies: this.currenciesFromOptions.filter(filter).map(currencyMapper),
          fromLimitTypes: uniqueFromLimitTypes,

          toOperators: this.checkedOperators,
          toTables: this.tablesToOptions.filter(filter).map(mapper),
          toCurrencies: this.currenciesToOptions.filter(filter).map(mapper),
          toLimitTypes: uniqueFromLimitTypes,

          rewriteExisting: this.rewriteExisting,
          removeExtraLimits: this.removeExtraLimits
        },
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(() => {
          this.$emit('finish')

          this.$refs['modal'].hide()

          this.$toastr.i('Success')

          this.$emit('close')
        })
        .catch(err => {
          this.$toastr.e(JSON.stringify(err.response.data.message))

          throw err
        })
    },
    toggleAllFromTables() {
      let tableFromOptions = this.tablesFromOptions

      this.tablesFromOptions = tableFromOptions.map(({ id, name }) => {
        return {
          id,
          name,
          checked: !tableFromOptions.some(({ checked }) => checked)
        }
      })
    },
    toggleAllToCurrencies() {
      let currenciesToOptions = this.currenciesToOptions

      this.currenciesToOptions = currenciesToOptions.map(({ id, name }) => {
        return {
          id,
          name,
          checked: !currenciesToOptions.some(({ checked }) => checked)
        }
      })
    },
    toggleAllToTables() {
      let tablesToOptions = this.tablesToOptions

      this.tablesToOptions = tablesToOptions.map(({ id, name }) => {
        return {
          id,
          name,
          checked: !tablesToOptions.some(({ checked }) => checked)
        }
      })
    },
    toggleAllFromCurrencies() {
      let currenciesFromOptions = this.currenciesFromOptions
      const shouldCheck = !currenciesFromOptions.some(({ checked }) => checked)

      if (shouldCheck) {
        // При включении всех - выбираем только валюты одного типа (первого доступного)
        const firstAvailableType = currenciesFromOptions.length > 0 ? currenciesFromOptions[0].limitType : null
        
        this.currenciesFromOptions = currenciesFromOptions.map(currency => {
          return {
            ...currency,
            checked: currency.limitType === firstAvailableType
          }
        })
      } else {
        // При выключении всех - просто снимаем все галочки
        this.currenciesFromOptions = currenciesFromOptions.map(currency => {
          return {
            ...currency,
            checked: false
          }
        })
      }
    },
    toggleAllToOperators() {
      this.loadOperatorsOptions(this.checkedOperators.length === 0)
    },
    loadFilter(isLoadingTablesFromOptions = false) {
      if (this.isLoadingFilter) {
        return
      }

      this.isLoadingFilter = true

      this.isLoadingTablesFromOptions = isLoadingTablesFromOptions
      this.isLoadingCurrenciesFromOptions = true
      this.isLoadingCurrenciesToOptions = true

      let chosenFromCurrencies = this.chosenFromCurrencies
      let chosenFromTables = this.chosenFromTables

      this.$store
        .dispatch('limits/loadCopyFilter', {
          operator: this.selectedOperator,
          tables: this.chosenFromTables.map(({ name }) => name)
        })
        .then(() => {
          this.isLoadingTablesFromOptions = false
          this.isLoadingCurrenciesFromOptions = false
          this.isLoadingCurrenciesToOptions = false

          if (this.chosenFromTables.length === 0) {
            this.tablesFromOptions = this.$store.getters[
              'limits/copyFilterTables'
            ].map(table => {
              return {
                id: table,
                name: table,
                checked: chosenFromTables.map(({ id }) => id).includes(table)
              }
            })
          }

          this.currenciesFromOptions = this.$store.getters[
            'limits/copyFilterCurrencies'
          ].map(currencyObj => {
            // Если это объект с currency, limitType, limitTypeName
            if (typeof currencyObj === 'object' && currencyObj.currency) {
              const displayName = `${currencyObj.currency} (${currencyObj.limitTypeName})`
              return {
                id: currencyObj.currency,
                name: displayName,
                displayName: displayName,
                currency: currencyObj.currency,
                limitType: currencyObj.limitType,
                limitTypeName: currencyObj.limitTypeName,
                checked: chosenFromCurrencies
                  .map(({ currency, limitType }) => `${currency}_${limitType}`)
                  .includes(`${currencyObj.currency}_${currencyObj.limitType}`)
              }
            } else {
              // Обратная совместимость со старым форматом
              return {
                id: currencyObj,
                name: currencyObj,
                displayName: currencyObj,
                currency: currencyObj,
                limitType: 0,
                limitTypeName: 'Default',
                checked: chosenFromCurrencies
                  .map(({ id }) => id)
                  .includes(currencyObj)
              }
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.isLoadingFilter = false
        })
    },
    loadOperatorsOptions(checked) {
      this.operatorsToCount = this.$store.getters[
        'operatorsForSelect/list'
      ].length
      let operatorsByPartner = {}
      this.$store.getters['operatorsForSelect/list']
        .sort((a, b) => {
          if (a.partnerName === b.partnerName) {
            return 0
          }

          if (!a.partnerName) {
            return 1
          }

          if (!b.partnerName) {
            return -1
          }

          return a.partnerName < b.partnerName ? -1 : 1
        })
        .forEach(({ label, value, partnerId, partnerName }) => {
          let key = partnerId ?? ''
          if (!operatorsByPartner[key]) {
            operatorsByPartner[key] = {
              partner: partnerName ?? 'Others',
              operators: [],
              checked: checked,
              partnerId: key
            }
          }
          operatorsByPartner[key].operators.push({
            id: value,
            name: label,
            checked: checked
          })
        })

      this.operatorsToMultiselectOptions = operatorsByPartner
    }
  },
  async beforeMount() {
    await this.$store.dispatch('tablesForSelect/loadList').then(() => {
      this.tablesToOptions = this.$store.getters['tablesForSelect/list'].map(
        ({ label, value }) => {
          return { id: value, name: label, checked: false }
        }
      )
    })

    await this.$store.dispatch('operatorsForSelect/loadList').then(() => {
      this.loadOperatorsOptions(false)
    })

    await this.$store.dispatch('currenciesForSelect/loadList').then(() => {
      this.currenciesToOptions = this.$store.getters[
        'currenciesForSelect/list'
      ].map(({ label, value }) => {
        return { id: value, name: label, checked: false }
      })
    })

    this.operatorOptions =
      this.$store.getters['limits/operatorsForSelect']?.map(option => {
        return { value: option.value, text: option.label }
      }) || []

    this.currencyOptions =
      this.$store.getters['limits/currenciesForSelect']?.map(option => {
        return { value: option.value, text: option.label }
      }) || []
  },
  watch: {
    selectedOperator() {
      this.tablesFromOptions = []
      this.tablesToOptions = this.tablesToOptions.map(table => ({
        ...table,
        checked: false
      }))
      this.loadFilter(true)
    },
    checkedPartners(newValue, oldValue) {
      newValue
        .filter(x => !oldValue.includes(x))
        .forEach(partnerId => {
          this.operatorsToMultiselectOptions[partnerId].operators.forEach(
            op => {
              op.checked = true
            }
          )
        })

      oldValue
        .filter(x => !newValue.includes(x))
        .forEach(partnerId => {
          this.operatorsToMultiselectOptions[partnerId].operators.forEach(
            op => {
              op.checked = false
            }
          )
        })
    },
    chosenFromTablesIds(newValue) {
      if (newValue.length <= 1) {
        return
      }

      this.tablesToOptions.forEach(item => {
        item.checked = newValue.includes(parseInt(item.id))
      })
    },
    chosenFromCurrenciesIds(newValue) {
      if (newValue.length <= 1) {
        return
      }

      this.currenciesToOptions.forEach(item => {
        item.checked = newValue.includes(item.id)
      })
    },
    chosenFromTablesString() {
      this.loadFilter()
    }
  }
}
</script>

<style scoped>
.min-height-scroll {
  max-height: 345px;
  min-height: 345px;
  overflow-y: scroll;
}

.operator-radio-group {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.operator-radio-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.custom-control {
  margin-bottom: 10px;
}

.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #007bff;
  border-color: #007bff;
}

.custom-control-label {
  cursor: pointer;
}

.toggle-link {
  background: none;
  border: none;
  color: #007bff;
  padding: 0;
  text-decoration: underline;
  text-decoration-style: dotted;
  margin-right: 20px;
}

.toggle-link:hover {
  background: none;
  color: #0056b3;
  text-decoration: underline;
  text-decoration-style: dotted;
}

.toggle-link:focus {
  box-shadow: none;
}

.toggle-link:active {
  background: none !important;
  color: #0056b3 !important;
}

.search-input-wrapper {
  position: relative;
}

.clear-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 0 5px;
  font-size: 14px;
}

.clear-button:hover {
  color: #666;
}
</style>
